import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

/**
 * Quick add buttons in the Shop Accessories mega menu.
 * Posts to /cart/add.js the same way product-form.js does, then dispatches
 * CartAddEvent so the cart drawer and cart items re-render as usual.
 */
document.addEventListener('click', async (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest('button[data-hdr-quick-add]');
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;

  event.preventDefault();
  if (button.getAttribute('aria-busy') === 'true') return;
  button.setAttribute('aria-busy', 'true');

  const variantId = button.dataset.hdrQuickAdd;
  const formData = new FormData();
  formData.append('id', variantId || '');
  formData.append('quantity', '1');

  const sectionIds = [];
  document.querySelectorAll('cart-items-component').forEach((item) => {
    if (item instanceof HTMLElement && item.dataset.sectionId) sectionIds.push(item.dataset.sectionId);
  });
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  try {
    const fetchCfg = fetchConfig('javascript', { body: formData });
    const response = await fetch(Theme.routes.cart_add_url, {
      ...fetchCfg,
      headers: { ...fetchCfg.headers, Accept: 'text/html' },
    });
    const data = await response.json();
    if (data.status) throw new Error(data.description || data.message);

    document.dispatchEvent(new CustomEvent('hdr:close-menus'));
    button.dispatchEvent(
      new CartAddEvent({}, button.id, {
        source: 'header-quick-add',
        itemCount: 1,
        productId: String(data.product_id ?? ''),
        variantId: String(variantId ?? ''),
        sections: data.sections,
      })
    );
    updateBadges();
  } catch (error) {
    console.error('Quick add failed', error);
    const product = button.closest('.hdr-quick__tile')?.querySelector('a.hdr-quick__name');
    if (product instanceof HTMLAnchorElement) window.location.href = product.href;
  } finally {
    button.removeAttribute('aria-busy');
  }
});

/** Keeps the header's cart count badge in sync after a quick add. */
async function updateBadges() {
  try {
    const cart = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());
    document.querySelectorAll('[data-hdr-cart-btn]').forEach((btn) => {
      let badge = btn.querySelector('.hdr-cart-badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'hdr-cart-badge';
        badge.setAttribute('aria-hidden', 'true');
        btn.appendChild(badge);
      }
      badge.textContent = String(cart.item_count);
      btn.setAttribute('aria-label', `Cart (${cart.item_count} items)`);
    });
  } catch (error) {
    // badge is cosmetic; the cart drawer already reflects the add
  }
}
